import PropTypes from "prop-types";
import React, { Component } from "react";
import { MenuButton } from "react-md";
class InsuranceFilterMenu extends Component {
  constructor(props) {
    super(props);
      this.click = this.click.bind(this);
      this.arrToObj = this.arrToObj.bind(this);
      this.title = props.title[0].toLowerCase();
  }

  UNSAFE_componentWillReceiveProps(newProps) {
    if(newProps.title !== this.title) {
      if(newProps.title !== undefined && newProps.title.length !== 0) {
        this.title = newProps.title[0].toLowerCase();
      }
    }
  }

  click(e) {
    this.props.onChange({
      term: this.props.term,
      title: [e.target.innerText.trim()],
      code: e.target.innerText.trim(),
      id: ""
    });
  }

  arrToObj(item) {
    const obj = {onClick: this.click, primaryText: item};
    return obj;
  }

  render() {
    return (
      <MenuButton
      id="menu-button-3"
      position={MenuButton.Positions.BELOW}
      raised
      menuItems={this.props.items.map(this.arrToObj)}
      iconChildren="arrow_drop_down"
    >
      {this.title}
    </MenuButton>
    );
  }
}

InsuranceFilterMenu.propTypes = {
  onChange: PropTypes.func.isRequired,
  title: PropTypes.array.isRequired,
  items: PropTypes.array.isRequired,
  term: PropTypes.string.isRequired,
};

export default InsuranceFilterMenu;